import { ILangTextValidation } from '~/types/main';

export const isMultiLanguageValid = (validation?: ILangTextValidation): boolean => {
  if (!validation) return true;
  return validation.enValid && validation.arValid;
};
